import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceControl: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVoiceControl"><Path d="M13 20H11V4H13V20Z" fill="currentColor"/><Path d="M9 17H7V7H9V17Z" fill="currentColor"/><Path d="M17 17H15V7H17V17Z" fill="currentColor"/><Path d="M5 15L1 12L5 9V15Z" fill="currentColor"/><Path d="M23 12L19 15V9L23 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceControl;
